import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { t } from '../../../i18n';
import { Button } from '../../../tornado/button/button.component';
import Spinner from '../../../tornado/spinner/spinner.component';
import { getInitialStyle } from './ssi.style';

export class SSIPairing extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Title: {
          text: {
            text: t('pairing.token.magenta.title'),
          },
        },
        Buttons: {
          Accept: {
            type: Button,
            label: t('pairing.token.magenta.accept'),
          },
          Decline: {
            type: Button,
          },
        },
        Spinner: {
          type: Spinner,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._index = 0;
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;

    // WARN: only static values are supported
    this.patch({
      Title: {
        text: {
          wordWrapWidth: value,
        },
      },
      Description: {
        text: {
          wordWrapWidth: value,
        },
      },
      Buttons: {
        w: value,
      },
    });
  }

  reset() {
    this.patch({
      Buttons: { visible: true },
      Spinner: { visible: false },
    });
  }

  _focus() {
    this._index = 0;
  }

  _getFocused() {
    return this.tag('Buttons').children[this._index];
  }

  _handleEnter() {
    const buttons = this.tag('Buttons');

    if (buttons.visible) {
      buttons.visible = false;
      this.tag('Spinner').visible = true;
      this.signal('accept');
    }
  }
}
